import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Users } from 'lucide-react'
import { useDeferredValue, useState } from 'react'
import { rpc } from '@/api/rpc'
import { Card } from '@/components/ui/card'
import { EmptyState } from '@/components/ui/empty-state'
import { Input } from '@/components/ui/field'
import { ContactRow } from '@/components/app/contact-row'

type Contact = {
  id: string
  full_name: string
  role: string | null
  email: string | null
  phone: string | null
  company: string | null
}

/** Contacts and companies. Reps see their own; staff see everyone. Deduped by email and phone on capture. */
export const Route = createFileRoute('/_app/contacts')({ component: Contacts })

function Contacts() {
  const [q, setQ] = useState('')
  const dq = useDeferredValue(q)
  const { data, isLoading } = useQuery({
    queryKey: ['contacts', 'page', dq],
    queryFn: () => rpc<Contact[]>('search_contacts', { q: dq, max_rows: 100 }),
  })
  return (
    <div className="mx-auto flex max-w-4xl flex-col gap-6">
      <h1 className="text-3xl uppercase">Contacts</h1>
      <Input
        aria-label="Search contacts"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Name, company or email"
      />
      {!isLoading && (data?.length ?? 0) === 0 && (
        <EmptyState icon={Users} title="No contacts yet">
          Contacts added on a Relux appear here.
        </EmptyState>
      )}
      <ul className="grid gap-3 sm:grid-cols-2">
        {data?.map((c) => (
          <li key={c.id}>
            <Card className="h-full p-4">
              <ContactRow c={{ ...c, role: c.role?.replace('_', ' ') }} />
            </Card>
          </li>
        ))}
      </ul>
    </div>
  )
}
